import React from 'react';
import { Alert } from 'reactstrap';

// The email address is now proof-of-ownership data: changing it sends a
// confirmation link to the NEW address and only swaps once that link is
// clicked. That flow lives entirely in the new dashboard, so the backend's
// userProfileUpdate deliberately ignores the `email` argument this legacy
// form still sends — the field looks editable and saves "successfully" while
// the address never moves.
//
// Rather than rebuild the verify-then-swap flow here, point people at the
// dashboard that has it. Every other field on these forms still saves.
//
// Hardcoded like NEW_SIGNUP_URL in website/Registration.js — appConfig carries
// API hosts, not the new dashboard's, and this is the same one-way pointer.
const NEW_PROFILE_URL = 'https://app.sparkapt.com/settings/profile';

export default function ManageProfileNotice() {
  return (
    <Alert color='info'>
      Email changes no longer save on this page — confirming a new address now
      happens in the new SparkAPT. Everything else here still saves as usual.
      <br />
      <a href={NEW_PROFILE_URL} target='_blank' rel='noreferrer'>
        Manage your profile in the new SparkAPT
      </a>
    </Alert>
  );
}
